<div *ngIf="getLoading()" class="cssload-container">
    <div class="cssload-speeding-wheel"></div>
</div>